import React, { useEffect, useState, forwardRef, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH, faPaperclip, faCheckCircle, } from "@fortawesome/free-solid-svg-icons";
import "./Comment.css";

import { getRandomColor, createImageFromInitials } from "../Utils";
import { Button } from "react-bootstrap";
import EditIcon from "../../assets/images/Edit.svg";
import DeleteIcon from "../../assets/images/trash.svg";
import { postTaskComments,getTaskActivityLog } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { VscTrash } from "react-icons/vsc";
import { FaRegComment,FaCircle } from "react-icons/fa";
import { FaRegUser ,FaCheck} from "react-icons/fa6";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const getIconByAction = (type) => {
  switch (type) {
    case "Attachment":
      return <FontAwesomeIcon icon={faPaperclip} style={{ fontSize: "12px" }} />;

    case "Attachment Removed":
      return <VscTrash style={{ fontSize: "12px" }} />;

    case "Assigned":
      return <FaRegUser icon={FaRegUser} style={{ fontSize: "12px" }} />;

    case "Assignment Completed":
      return <FaCheck icon={FaCheck} style={{ fontSize: "10px" }} />;

    case "Comment":
      return <FaRegComment icon={FaRegComment} style={{ fontSize: "14px" }} />;

    default:
      return <FaCircle style={{ fontSize: "6px", color: "black" }} />;
    
  }
};
const CommentItemComponent = ({
  comment,
  onDelete,
  onSaveEdit,
  textAreaRef,
  currentUser,
  activityFilter,
  isSystem,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedText, setEditedText] = useState(comment.content);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const isUserComment = comment.comment_type === "Comment";
  const color = getRandomColor(comment.full_name);
  
 const isOwner = currentUser&& comment.owner && String(currentUser).toLowerCase() === String(comment.owner).toLowerCase();
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
 const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleMenuClick = () => {
    setMenuOpen(!isMenuOpen);
  };

  const username = localStorage.getItem("full_name");
  const handleEditClick = () => {
    setIsEditing(true);
  };
  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditedText(comment.content);
    setMenuOpen(false);
  };

  const handleSaveEdit = () => {
    onSaveEdit(comment.name, editedText);
    setIsEditing(false);
    setMenuOpen(false); 
  };

 return (

   
<div className={`log-item ${isUserComment ? "user-comment" : "system-log"}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setMenuOpen(false);
      }}
      style={{ position: 'relative' }} 
    >
    <div
      className={`avatar-circle ${
        comment.comment_type === "System" ? "no-bg" : ""
      }`}
    >
      {getIconByAction(comment.comment_type)}
    </div>    
      <div className="log-content-wrapper" style={{ width: '100%' ,marginTop: "3px"}}>
        {!isUserComment && (
        <div className="log-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
             {comment.comment_type !== "Assignment Completed" &&
              comment.comment_type !== "Assigned"  && (
            <span className="log-user">{isOwner ? "You" : (comment.full_name || "System")}</span>)}
            <span className="log-action" style={{ fontSize: "12px" }}>
           {isUserComment ? " commented" : comment.display_text}
            </span>
            <span className="log-time" style={{ marginLeft: "10px", fontSize: '11px' }}> • {comment.creation}</span>
          </div>
        </div>
        )}

      <div className="log-body" style={{ marginTop: "5px" }}>
      {isEditing ? (
      <div className="edit-container">
      <textarea
        className="comment-textarea"
        value={editedText}
        onChange={(e) => setEditedText(e.target.value)}/>
      <div className="edit-actions">
        <Button className="btn-cancel" size="sm" onClick={() => setIsEditing(false)}>
          Cancel
        </Button>
        <Button className="btn-save" size="sm" onClick={handleSaveEdit}>
          Save
        </Button>
      </div>
    </div>
  ) : (
    <>{isUserComment ?(
      <div className="comment-card">
      <div className="comment-card-header">
      <div className="comment-user-info">
      <div className="comment-avatar" style={{color: color,backgroundColor: `${color}1A`}}>
           {comment.full_name
            ?.split(" ")
            .map(n => n[0])
            .join("")
            .toUpperCase()}
        </div>
        <div className="comment-meta">
          <span className="comment-name">
            {isOwner ? "You" : comment.full_name}
          </span>
          <span className="comment-action"> commented</span>
          <span className="comment-time"> · {comment.creation}</span>
        </div>
      </div>

      {isOwner && (
     <div className="comment-actions" style={{ position: "relative", display: "flex", alignItems: "center" }}>
     <span
      onClick={() => setIsEditing(true)}
      style={{ cursor: "pointer" }}
    >
      Edit
    </span>
    <FontAwesomeIcon
      icon={faEllipsisH}
      style={{ marginLeft: "10px", cursor: "pointer" }}
      onClick={() => setMenuOpen(!isMenuOpen)}
    />

    {isMenuOpen && (
      <div
        style={{
          position: "absolute",
          right: 0,
          top: "25px",
          background: "#fff",
          border: "1px solid #d1d8dd",
          borderRadius: "6px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          zIndex: 10
        }}
      >
        <div
          style={{
            padding: "8px 12px",
            cursor: "pointer",
            color: "red"
          }}
          onClick={() => {
            onDelete(comment.name);
            setMenuOpen(false);
          }}
        >
          Delete
        </div>
      </div>
    )}
  </div>
)}
    </div>
    <div className="comment-divider"></div>
    <div className="comment-card-body">
      {comment.content}
    </div>
  </div>
) : null}
    </>
  )}
</div>
      </div>
    </div>
  );
};

const CommentSection = ({
  logo,
  fullScreenMode,
  taskId,
  commentsData,
  onAddComment,
  onEditComment,
  onDeleteComment,
  currentUser
  
}) => {
  const dispatch = useDispatch();
  const postTaskCommentsData = useSelector(
    (state) => state.postTaskCommentsData
  );
  const username = localStorage.getItem("full_name");
  const [commentedBy, setCommentedBy] = useState("");
  const [content, setContent] = useState("");
  const [editingCommentId, setEditingCommentId] = useState(null);
   const activityLogs = useSelector((state) => state.fetchGetTaskActivityLog?.data || []);
   const postStrategyFunctionDetails = useSelector(
       (state) => state.postStrategyFunctionDetails
     );
const [activityFilter, setActivityFilter] = useState("comments");
const filteredLogs =
  activityFilter === "comments"
    ? activityLogs.filter((log) => log.comment_type === "Comment"||log.comment_type==="System")
    : activityLogs;
 
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const textAreaRef = useRef(null);
  useEffect(() => {
    
    if (taskId) {
      dispatch(getTaskActivityLog("Task", taskId));
      
    }
    
  }, [taskId, postStrategyFunctionDetails]);
 useEffect(() => {
  
  if(postTaskCommentsData && 
     (postTaskCommentsData.action === "add" || 
      postTaskCommentsData.action === "edit" || 
      postTaskCommentsData.action === "delete")) {
  
      dispatch(getTaskActivityLog("Task", taskId));

    
        textAreaRef?.current?.scrollIntoView({ behavior: "smooth" });
        textAreaRef?.current?.focus();
    }
  }, [postTaskCommentsData]);
  useEffect(() => {
  // when task changes, remove focus
  const sidebarBody = document.querySelector(".gtm-sidebar-body");

  if (sidebarBody) {
    sidebarBody.scrollTop = 0;
  }
  
  if (textAreaRef.current) {
    textAreaRef.current.blur();
  }
  }, [taskId]);
 
 const handleEdit = (name) => {
    const commentToEdit = commentsData.find((item) => item.name === name);

    setEditingCommentId(name);
    setContent(commentToEdit.content);
  };

  const handleSaveEditComment = (commentId, newContent) => {
    dispatch(postTaskComments(newContent, false, "edit", commentId));
    onEditComment(commentId, newContent);
    setEditingCommentId(null);
  };

  const handleDelete = (commentId) => {
    dispatch(postTaskComments(false, false, "delete", commentId));
    onDeleteComment(commentId);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedContent = content?.trim();
    if (!trimmedContent) return;

    dispatch(postTaskComments(trimmedContent, taskId, "add", false));
    setCommentedBy("");
    setContent("");
  };

  return (
    <div className="comment-section-container ">
      <div className="comment-section-heading" style={{ padding: "5px" }}>
        Comment Section
      </div>
      <div>
        <div style={{ position: "relative" }}>
          <div
            style={{
              backgroundColor: "#f8fafb",
            }}
          >
            <div
              // onSubmit={handleSubmit}
              // style={{ display: "flex", justifyContent: "left" }}
            >
              <div style={{ width: "100%" }}>
                <textarea
                  disabled={
                    selectedSubMenuPermission === "write" ||
                    selectedSubMenuPermission === "admin"
                      ? false
                      : true
                  }
                  rows={3}
                  className="comment-textarea"
                  placeholder="Add a comment..."
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  ref={textAreaRef}
                />
              </div>
              <div className="comment-action-row">
              <Button
                disabled={
                  selectedSubMenuPermission === "write" ||
                  selectedSubMenuPermission === "admin"
                    ? false
                    : true
                }
                style={{
                  backgroundColor: "rgb(10, 95, 89)",
                  width: "fit-content",
                  marginLeft: "10px",
                }}
                className="submit-buttons"
                type="button"
                onClick={handleSubmit}
              >
                Comment
              </Button>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end",marginTop: "6px",marginRight: "20px" }}>
           <FormControlLabel
           control={
          <Checkbox
           size="small"
            onChange={(e) =>
            setActivityFilter(e.target.checked ? "all" : "comments")
             }
           sx={{
             color: "#b0b8c4",
            "&.Mui-checked": {
            color: "rgb(10, 95, 89)"
             }
             }}
          />
          }
           label="Show Activity Log"
          sx={{
              margin: 0,
             ".MuiFormControlLabel-label": {
              fontSize: "13px",
               color: "#4b5563",
               fontWeight: 500
              }
            }}
             />
                 </div>

            </div>
            </div>
           
           <div className="comment-list activity-log-container">
             <div className="timeline-content">
             {filteredLogs.length > 0 ? (
             filteredLogs.map((logItem) => (
                  <CommentItemComponent
                    textAreaRef={textAreaRef}
                    key={logItem.name}
                    comment={logItem}
                    onDelete={handleDelete}
                    onSaveEdit={handleSaveEditComment}
                    currentUser={currentUser}
                  />
                ))
              ):(
             <div style={{ textAlign: "center", color: "#888", padding: "20px" }}>
               No activity yet.
             </div>
           )}
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentSection;
